import { PROJECT } from '@dealstack/shared/lib/common/environment';
import React, { PropsWithChildren, useContext } from 'react';

const AppTypeContext = React.createContext<PROJECT>(PROJECT.ADMIN);
export function useAppType() {
	const context = useContext(AppTypeContext);
	if (!context) {
		throw new Error('useAppType can only be used inside of AppTypeProvider');
	}
	return context;
}

export function AppTypeProvider(props: PropsWithChildren<{ appType: PROJECT }>) {
	return (
		<AppTypeContext.Provider value={props.appType}>{props.children}</AppTypeContext.Provider>
	);
}
